























import { Event } from 'inscreva-sse-models';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { EventUI } from '../models/event-ui';
import EventDetails from './EventDetailsComponent.vue';
import SignUpForm from './SignUpForm.vue';

@Component({
  components: {
    EventDetails,
    SignUpForm,
  },
})
export default class SignUpComponent extends Vue {
  @Prop({ required: true })
  eventUI: EventUI;

  get event() {
    return this.eventUI.event as Event;
  }
}
